import { doorLeftFull, doorRightFull } from '@/assets/ui'
import { DoorConfig } from '@/components/DevTools/DoorEditor'

interface SlidingDoorsProps {
  isOpen: boolean
  config: DoorConfig
}

/**
 * Раздвижные японские двери
 * - ОДНИ двери, полноценные с волнами внизу
 * - Нижний край дверей = верхний край BetPanel
 * - В открытом состоянии: уходят за края, видны только visibleEdge px с каждой стороны
 * - В закрытом состоянии: съезжаются к центру, стыкуются ровно посередине
 */
export default function SlidingDoors({ isOpen, config }: SlidingDoorsProps) {
  const { panelHeight, visibleEdge, doorWidth } = config
  
  return (
    <div 
      className="absolute left-0 right-0 top-0 z-40 pointer-events-none overflow-hidden flex"
      style={{ bottom: `${panelHeight}px` }}
    >
      {/* Левая дверь */}
      <div 
        className="h-full flex-shrink-0 transition-transform duration-500 ease-out flex justify-end overflow-hidden"
        style={{
          width: `${doorWidth}%`,
          transform: isOpen ? `translateX(calc(-100% + ${visibleEdge}px))` : 'translateX(0)',
          willChange: 'transform',
          backfaceVisibility: 'hidden',
        }}
      >
        <img 
          src={doorLeftFull}
          alt=""
          className="h-full object-cover"
          style={{ 
            minWidth: '100%',
            objectPosition: 'right bottom',
            filter: 'drop-shadow(4px 0 10px rgba(0,0,0,0.5))',
          }}
          draggable={false}
        />
      </div>
      
      {/* Правая дверь */}
      <div 
        className="h-full flex-shrink-0 transition-transform duration-500 ease-out flex justify-start overflow-hidden"
        style={{
          width: `${doorWidth}%`,
          transform: isOpen ? `translateX(calc(100% - ${visibleEdge}px))` : 'translateX(0)',
          willChange: 'transform',
          backfaceVisibility: 'hidden',
        }}
      >
        <img 
          src={doorRightFull}
          alt=""
          className="h-full object-cover"
          style={{ 
            minWidth: '100%',
            objectPosition: 'left bottom',
            filter: 'drop-shadow(-4px 0 10px rgba(0,0,0,0.5))',
          }}
          draggable={false}
        />
      </div>
    </div>
  )
}

